<div
  class="xux"
  [class.xux-single-group-form]="xuxSingleGroupForm"
  data-e2e-id="editor-wrapper"
  [attr.transaction]="saveOperationId"
>
  <div class="header-panel">
    <button class="btn-close" (click)="closeBtnClick()" type="button">
      <i class="glyphicon xicon-close"></i>
    </button>
    <div class="header-panel-titles">
      <div class="header-panel-subtitle">{{ entityTitle | translate }}</div>
      <div class="header-panel-title">
        {{ title | translate }}
        <span *ngIf="showItemEditedMark$ | async" class="header-panel-edited-mark">({{ staticTextContent.edited | translate }})</span>
      </div>
    </div>
    <div class="xux-dropdown btn-group pull-right">
      <ng-container *ngFor="let button of (pageTopButtons$ | async) || []; trackBy: getButtonValue">
        <button
          type="button"
          *ngIf="!(isButtonHiddenObs(button) | async) && showForm"
          [attr.data-e2e-id]="button.value"
          [style.order]="button.flexOrder"
          [disabled]="(isButtonDisabledObs(button) | async)"
          [ngClass]="button.class"
          (appThrottleClick)="handleTopSectionBtnClick(button)"
        >
          {{ ((button.captionObs | async) || button.caption) | translate }}
        </button>
      </ng-container>
      <button
        type="button"
        [disabled]="(isRequestPendingForEditor$ | async) || disabledChildButtonDropdown"
        class="btn btn-default btn-primary dropdown-toggle"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        data-e2e-id="edit-xux-btn-toggle-dropdown"
        *ngIf="!isDeletedDocument && showDropdownOptions"
      >
        <i class="glyphicon glyphicon-menu-down"></i>
        <span class="sr-only">{{ staticTextContent.ToggleDropdown |translate }}</span>
      </button>
      <ul
        #childButtonsList
        class="dropdown-menu"
        *ngIf="!(isRequestPendingForEditor$ | async) && !isDeletedDocument  && showDropdownOptions"
      >
        <ng-container *ngFor="let dropdownButton of (pageTopDropdownButtons$ | async) || []; trackBy: getButtonValue">
          <li *ngIf="!(isButtonHiddenObs(dropdownButton) | async)">
            <a (click)="handleTopSectionBtnClick(dropdownButton)" [attr.data-e2e-id]="dropdownButton.value"
              >{{ ((dropdownButton.captionObs | async) || dropdownButton.caption) | translate }}</a
            >
          </li>
        </ng-container>
      </ul>
    </div>
    <button
    *ngIf="document?._id && showAuditTrailButton && canViewAuditTrail"
    type="button"
    class="btn btn-default btn-primary pull-right print-btn"
    (appThrottleClick)="auditTrailBtnClick()"
  >
    {{ staticTextContent.AuditTrail | translate }}
  </button>
    <div class="xux-dropdown btn-group pull-right export-pdf-btn-group" *ngIf="showExportButton">
      <button
        type="button"
        class="btn btn-default"
        (appThrottleClick)="exportPdfClickHandler()"
        [disabled]="disabledPrintOrExportPdf()"
        data-e2e-id="edit-xux-btn-save"
      >
        {{ exportButtonText | translate }}
      </button>
      <button
        type="button"
        [disabled]="disabledPrintOrExportPdf()"
        *ngIf="showToggleExportButtons"
        class="btn btn-default dropdown-toggle"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        data-e2e-id="edit-xux-btn-toggle-dropdown"
      >
        <i class="glyphicon glyphicon-menu-down"></i>
        <span class="sr-only">{{ staticTextContent.ToggleDropdown |translate }}</span>
      </button>
      <ul class="dropdown-menu">
        <li>
          <a (appThrottleClick)="exportCsvClickHandler()" data-e2e-id="export-csv-btn">{{ staticTextContent.ExportCSV | translate }}</a>
        </li>
      </ul>
    </div>
    <button
      *ngIf="canPrint"
      type="button"
      class="btn btn-default pull-right print-btn"
      (appThrottleClick)="printPdfClickHandler()"
      [disabled]="disabledPrintOrExportPdf()"
      data-e2e-id="edit-xux-btn-print">
      {{ staticTextContent.Print | translate }}
    </button>
    <button
      type="button"
      class="btn btn-default pull-right print-btn"
      *ngIf="showToggleEmptyPrintButtons"
      (appThrottleClick)="printEmptyColumnPdf()"
      [disabled]="disabledPrintEmptyColumnBtn()"
      data-e2e-id="edit-xux-btn-empty-print">
      {{printEmptyColumnBtnText | translate }}
    </button>
    <xvi-toolbar alignRight="true" [buttons]="dynamicHeaderButtons"> </xvi-toolbar>
    <ng-container #selectContainer></ng-container>
    <xux-save-status class="pull-right"></xux-save-status>
  </div>

  <xux-document-info-error-message *ngIf="isDocumentWithMessage()" [messageData]="infoMessageData$ | async">
  </xux-document-info-error-message>

  <xux-schema-form
    #xuxSchemaForm
    *ngIf="showForm"
    [form]="form"
    [groups]="groups"
    [bannerText]="bannerText"
    [errors]="errors"
    [expandSidebar]="expandSidebar"
    [showSidebarCollapsedBtn]="showSidebarCollapsedBtn"
    [documentSidebarDetails]="documentSidebarDetails"
    [enableRightExpand]="enableRightExpand$ | async"
    [rightExpanded$]="rightExpanded$"
    [rightFormsConfig]="rightFormsConfig"
    [disabledFunc]="disabledFunc"
    [groupIndexControl]="groupIndexControl"
    [beforeChange]="beforeFormGroupChange"
    (onFormAction)="onFormAction($event)"
    (onRightFormAction)="onRightFormAction($event)"
  >
  </xux-schema-form>

  <xvi-drawer-popup
    *ngIf="detailDrawerPopupOptions !== null"
    [show]="showDetailDrawerPopup"
    [withoutPadding]="true"
    [showLoader]="detailDrawerPopupOptions.showLoader"
    (close)="closeDrawer()"
  >
    <xvi-detail-drawer-form
      #drawerContainer
      *ngIf="showDetailDrawerPopup"
      [show]="showDetailDrawerPopup"
      [options]="detailDrawerPopupOptions"
      [document]="detailDrawerPopupDocument"
      (close)="closeDrawer()"
    >
    </xvi-detail-drawer-form>
  </xvi-drawer-popup>
</div>
